export function roundToOneDecimal(num?: number | null): string {
  return typeof num === 'number' ? num.toFixed(1) : '0.0'
}
